import type { ApiMode } from './runtime';

export const backendFeatureRegistry = {
  authentication: {
    title: 'Вход в аккаунт',
    description: 'Cookie-сессия с безопасной CSRF-защитой подключена к backend API.',
    available: true,
  },
  analyticsDynamics: {
    title: 'Динамика',
    description: 'История метрик регулярных запусков подключена к backend API.',
    available: true,
  },
  serpResults: {
    title: 'Просмотр результатов',
    description: 'Индекс запросов, разобранная выдача и исходные снэпшоты подключены к backend.',
    available: true,
  },
  serpComparison: {
    title: 'Сравнение выдачи',
    description: 'Сравнение позиций и покрытия между запусками подключено к backend API.',
    available: true,
  },
  taskDashboard: {
    title: 'Центр заданий',
    description: 'Сводные данные заданий пока не интегрированы с backend.',
    available: false,
  },
  searchTargets: {
    title: 'Цели',
    description: 'Сохранённые правила поиска URL для аналитики.',
    available: true,
  },
  baskets: {
    title: 'Корзины запросов',
    description: 'Корзины и запросы подключены к backend API.',
    available: true,
  },
  credentials: {
    title: 'Подключения',
    description: 'Подключения Yandex Search API управляются через backend.',
    available: true,
  },
  experiments: {
    title: 'Единоразовые задания',
    description: 'Создание, запуск и наблюдение за экспериментами подключены к backend.',
    available: true,
  },
  crons: {
    title: 'Регулярные задания',
    description: 'Расписания, состояния и история запусков подключены к backend.',
    available: true,
  },
} as const;

export type BackendFeature = keyof typeof backendFeatureRegistry;

export function isFeatureAvailable(feature: BackendFeature, apiMode: ApiMode): boolean {
  return apiMode === 'mock' || backendFeatureRegistry[feature].available;
}
